import * as types from '../constants/action-types';

const defaultState = {
    hasError: false,
    error: {},
    message: '',
    scripts: []
};

const globalReducer = (state = defaultState, action) => {
    const {
        hasError = false,
        hasSuccess = false,
        message = '',
        scripts = []
    } = state;

    switch (action.type) {
        case types.FAILED_ACTION:
            return {
                hasError: true,
                hasSuccess: false,
                message: action.message,
                scripts
            };
            break;
        case types.SUCCESS_ACTION:
            return {
                hasError: false,
                hasSuccess: true,
                message: action.message,
                scripts
            };
            break;
        case types.CLEARED_MESSAGE:
            return {
                hasError: false,
                hasSuccess: false,
                message: '',
                scripts
            };
            break;
        default:
            return {
                hasError,
                hasSuccess,
                message,
                scripts
            };
            break;
}
};
export default globalReducer;